import VueRouter from 'vue-router'
// import Vue from 'vue'
import Vue from 'vue/dist/vue.esm.js'//我们自己找到的带解析的版本
Vue.use(VueRouter)

var router=new VueRouter({
    routes:[
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/en_home',
			component: () => import('@/views/home/en_home.vue'),
		},
		{
		    path: '/home',
		    component: () => import('@/views/home/home.vue'),
		},
		{
		    path: '/gnzx',
		    component: () => import('@/views/news/gnzx.vue'),
		},
		{
		    path: '/gnzx_xqy',
		    component: () => import('@/views/news/gnzx_xqy.vue'),
		},
		{
		    path: '/yjdt',
		    component: () => import('@/views/news/yjdt.vue'),
		},
		{
		    path: '/yjdt_xqy',
		    component: () => import('@/views/news/yjdt_xqy.vue'),
		},
		{
		    path: '/bwggk',
		    component: () => import('@/views/into_museum/bwggk.vue'),
		},
		{
		    path: '/zzjg',
		    component: () => import('@/views/into_museum/zzjg.vue'),
		},
		{
		    path: '/fzlc',
		    component: () => import('@/views/into_museum/fzlc.vue'),
		},
		{
		    path: '/dsjj',
		    component: () => import('@/views/into_museum/dsjj.vue'),
		},
		{
			path: '/gcjp',
			component: () => import('@/views/collection_essence/gcjp.vue'),
		},
		{
			path: '/gcjp_xqy',
			component: () => import('@/views/collection_essence/gcjp_xqy.vue'),
		},
		{
			path: '/ztsc',
			component: () => import('@/views/collection_essence/ztsc.vue'),
		},
		{
			path: '/ztsc_xqy',
			component: () => import('@/views/collection_essence/ztsc_xqy.vue'),
		},
		{
			path: '/clzl',
			component: () => import('@/views/visit_service/clzl.vue'),
		},
		{
			path: '/jbzl_details',
			component: () => import('@/views/visit_service/jbzl_details.vue'),
		},
		{
			path: '/ztzl_details',
			component: () => import('@/views/visit_service/ztzl_details.vue'),
		},
		{
			path: '/ywzl_details',
			component: () => import('@/views/visit_service/ywzl_details.vue'),
		},
		{
			path: '/hyzj',
			component: () => import('@/views/visit_service/hyzj.vue'),
		},
		{
			path: '/hyzj_details',
			component: () => import('@/views/visit_service/hyzj_details.vue'),
		},
		{
			path: '/cgzn',
			component: () => import('@/views/visit_service/cgzn.vue'),
		},
		{
			path: '/mpyy',
			component: () => import('@/views/visit_service/mpyy.vue'),
		},
		{
			path: '/dlfw',
			component: () => import('@/views/visit_service/dlfw.vue'),
		},
		{
			path: '/hdyy',
			component: () => import('@/views/teaching_activities/hdyy.vue'),
		},
		{
			path: '/hdyy_details',
			component: () => import('@/views/teaching_activities/hdyy_details.vue'),
		},
		{
			path: '/jchg',
			component: () => import('@/views/teaching_activities/jchg.vue'),
		},
		{
			path: '/jchg_details',
			component: () => import('@/views/teaching_activities/jchg_details.vue'),
		},
		{
			path: '/zyzzc',
			component: () => import('@/views/teaching_activities/zyzzc.vue'),
		},
		{
			path: '/zyzzc_zc',
			component: () => import('@/views/teaching_activities/zyzzc_zc.vue'),
		},
		{
			path: '/zyzzc_details',
			component: () => import('@/views/teaching_activities/zyzzc_details.vue'),
		},
		{
			path: '/dekt',
			component: () => import('@/views/teaching_activities/dekt.vue'),
		},
		{
			path: '/dekt_details',
			component: () => import('@/views/teaching_activities/dekt_details.vue'),
		},
		{
			path: '/grxx',
			component: () => import('@/views/user_center/grxx.vue'),
		},
		{
			path: '/wddz',
			component: () => import('@/views/user_center/wddz.vue'),
		},
		{
			path: '/wdhdyy',
			component: () => import('@/views/user_center/wdhdyy.vue'),
		},
		{
			path: '/wdhdyy_details',
			component: () => import('@/views/user_center/wdhdyy_details.vue'),
		},
		{
			path: '/wdmpyy',
			component: () => import('@/views/user_center/wdmpyy.vue'),
		},
		{
			path: '/wdmpyy_details',
			component: () => import('@/views/user_center/wdmpyy_details.vue'),
		},
		{
			path: '/wdsc',
			component: () => import('@/views/user_center/wdsc.vue'),
		},
		{
			path: '/wcsd',
			component: () => import('@/views/shop/wcsd.vue'),
		},
		{
			path: '/wcsd_details',
			component: () => import('@/views/shop/wcsd_details.vue'),
		},
		{
			path: '/login',
			component: () => import('@/views/login/login.vue'),
		},
		{
			path: '/register',
			component: () => import('@/views/login/register.vue'),
		},
		{
			path: '/xxzy',
			component: () => import('@/views/second_classroom/xxzy.vue'),
		},
		{
			path: '/zxkt',
			component: () => import('@/views/second_classroom/zxkt.vue'),
		},
		{
			path: '/jslt',
			component: () => import('@/views/luntan/jslt.vue'),
		},
		{
			path: '/video_player',
			component: () => import('@/views/video_player/video_player.vue'),
		},
		{
			path: '/search',
			component: () => import('@/views/search/search.vue'),
		},
		{
			path: '/news_video',
			component: () => import('@/views/news_video/news_video.vue'),
		},
		{
			path: '/news_video_details',
			component: () => import('@/views/news_video/news_video_details.vue'),
		},
		{
			path: '/zjgg',
			component: () => import('@/views/wwzj/zjgg.vue'),
		},
		{
			path: '/jzzs',
			component: () => import('@/views/wwzj/jzzs.vue'),
		},
		{
			path: '/young_index',
			component: () => import('@/views/young/index.vue'),
		},
		{
			path: '/qwzs',
			component: () => import('@/views/young/qwxzs.vue'),
		},
		{
			path: '/xxhj',
			component: () => import('@/views/young/xxhj.vue'),
		},
		{
			path: '/kpxjt',
			component: () => import('@/views/young/kpxjt.vue'),
		},
		{
			path: '/zyzs',
			component: () => import('@/views/young/zyzs.vue'),
		},
		{
			path: '/hdyx',
			component: () => import('@/views/young/hdyx.vue'),
		},
		{
			path: '/basicdisplay',
			component: () => import('@/views/exhibitions/basic_display.vue'),
		},
		{
			path: '/basic_display_details',
			component: () => import('@/views/exhibitions/basic_display_details.vue'),
		},
		{
			path: '/temporarydisplay',
			component: () => import('@/views/exhibitions/temporary_display.vue'),
		},
		{
			path: '/temporary_display_details',
			component: () => import('@/views/exhibitions/temporary_display_details.vue'),
		},
		{
			path: '/pastdisplay',
			component: () => import('@/views/exhibitions/past_display.vue'),
		},
		{
			path: '/past_display_details',
			component: () => import('@/views/exhibitions/past_display_details.vue'),
		},
		{
			path: '/collectionquality',
			component: () => import('@/views/collections/collection_quality.vue'),
		},
		{
			path: '/collection_quality_details',
			component: () => import('@/views/collections/collection_quality_details.vue'),
		},
		{
			path: '/themecollection',
			component: () => import('@/views/collections/theme_collection.vue'),
		},
		{
			path: '/theme_collection_details',
			component: () => import('@/views/collections/theme_collection_details.vue'),
		},
		{
			path: '/noticevisitors',
			component: () => import('@/views/visit/noticevisitors.vue'),
		},
		{
			path: '/tourguide',
			component: () => import('@/views/visit/tourguide.vue'),
		},
		{
			path: '/earningresource',
			component: () => import('@/views/education/earningresource.vue'),
		},
		{
			path: '/onlinecourses',
			component: () => import('@/views/education/onlinecourses.vue'),
		},
		{
			path: '/onlinecourses_details',
			component: () => import('@/views/education/onlinecourses_details.vue'),
		},
		{
			path: '/ticketbooking',
			component: () => import('@/views/reservation/ticket_booking.vue'),
		},
		{
			path: '/displayList',
			component: () => import('@/views/exhibitions/displayList.vue'),
		},
		{
			path: '/cgly',
			component: () => import('@/views/cgly/cgly.vue'),
		},
		{
			path: '*',
			redirect: '/home'
		},
		{
			path: '/mpyy1',
			component: () => import('@/views/visit_service/mpyy1.vue'),
		},
		{
			path: '/config',
			component: () => import('@/views/visit_service/config.vue'),
		},
		{
			path: '/filinginfo',
			component: () => import('@/views/filling/filingInfo.vue'),
		}
	],
	//mode:'history'
})

router.beforeEach((to, from, next) => {
	// console.log(to.path===from.path)
	if(to.path===from.path){
		return
    } else {
		next()
	}
})

export default router

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js